import React, { useState } from 'react';
import { Table, Card, Button, Tag, Space, Upload, Input, Modal, message, Descriptions } from 'antd';
import { UploadOutlined, FileTextOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';

const DocumentManagementModule = () => {
  const [data, setData] = useState([
    { id: 1, title: '碳储量反演算法说明 V2.1', type: 'PDF', uploader: '张工', date: '2025-11-25', status: '已审核' },
    { id: 2, title: '实验数据集2025Q3', type: 'ZIP', uploader: '王研究员', date: '2025-11-20', status: '待审核' },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const columns = [
    { title: '文档标题', dataIndex: 'title', render: t => <><FileTextOutlined /> {t}</> },
    { title: '类型', dataIndex: 'type', render: t => <Tag color="blue">{t}</Tag> },
    { title: '上传者', dataIndex: 'uploader' },
    { title: '上传时间', dataIndex: 'date' },
    { title: '状态', dataIndex: 'status', render: s => <Tag color={s === '已审核' ? 'green' : 'orange'}>{s}</Tag> },
    {
      title: '操作', key: 'action', render: (_, record) => (
        <Space>
          <Button type="link" size="small">下载</Button>
          <Button type="link" size="small" danger onClick={() => {
            setData(data.filter(item => item.id !== record.id));
            message.success('删除成功');
          }}>删除</Button>
        </Space>
      )
    }
  ];

  const handleUpload = (info) => {
    if (info.file.status === 'done') {
      message.success(`${info.file.name} 上传成功`);
      setData([...data, {
        id: Date.now(),
        title: info.file.name,
        type: info.file.name.split('.').pop().toUpperCase(),
        uploader: '当前用户',
        date: new Date().toLocaleDateString(),
        status: '待审核'
      }]);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="项目文档管理" extra={
        <Space>
          <Input placeholder="搜索文档..." prefix={<SearchOutlined />} />
          <Upload showUploadList={false} customRequest={({ onSuccess }) => setTimeout(() => onSuccess("ok"), 1000)} onChange={handleUpload}>
            <Button type="primary" icon={<UploadOutlined />}>上传文档</Button>
          </Upload>
        </Space>
      }>
        <Table columns={columns} dataSource={data} rowKey="id" />
      </Card>
    </div>
  );
};

export default DocumentManagementModule;